'use client'
import Link from 'next/link'
import Image from 'next/image'

import CMButton from '@/components/layout/buttons/cmButton'
import NewsletterSignUp from './footerNewsletterSignUp'
import {
  MenuItem,
  reportIncidentSvg,
  reportIndividualSvg,
} from '@/components/layout/main-navigation'
import { Layout } from '@/payload-types'
import SocialMediaLink from '@/components/layout/social-link/social-link'
import React from 'react'
import { SocialLinkItem } from '@/components/layout/social-link/social-link'
import { Toaster } from '@/components/ui/toaster'
import { CANARY_MISSION } from '@/enum/enum'
interface IProps {
  layout: Layout | null | undefined
}

export const Footer = ({ layout }: IProps) => {
  return (
    <>
      <div className="z-[9999] fixed w-full top-0 border-none">
        <Toaster />
      </div>
      <footer className="text-feMy1 xl:h-[515px] h-[380px] bg-black pt-[15px] pb-0 max-[768px]:h-[auto]">
        <div className="flex justify-center">
          <div className="max-[1200px]:w-[834px] max-[768px]:max-w-full w-[1200px] max-[1200px]:h-[314px] max-[768px]:h-full h-[422px] max-[768px]:mx-5 bg-black items-center">
            <div className="max-[768px]:w-1/2 max-[768px]:flex max-[768px]:justify-center max-[433px]:w-auto max-[433px]:contents">
              <Image
                loading="eager"
                className="max-[1200px]:mb-[9px] max-[768px]:mx-0 ms-[30px] max-[1200px]:w-[200px] w-[310px]  max-[1200px]:h-[56px] h-[94px]"
                alt="Logo"
                width={310}
                height={94}
                src="/images/favicons/Logo SVG-03.svg"
              />
            </div>
            <div className="min-[768px]:hidden fl">
              <NewsletterSignUp
                {...{
                  newsletterText: layout?.footer?.navigationBar?.rightNavigationBar?.newsletterText,
                }}
              />
            </div>
            <div className="flex flex-row justify-evenly max-[1200px]:h-[242px] h-[326px] max-[1200px]:items-start items-center max-[1200px]:p-0 max-[768px]:pt-[20px]">
              <div className="max-[1200px]:hidden flex w-[338px] h-[260px] gap-5 flex-col items-center px-0">
                <p className="text-[19px] font-semibold uppercase leading-[28.5px] m-0">
                  {layout?.footer?.navigationBar?.leftNavigationBar?.beforeDonateText1}
                </p>
                <p className="text-[17px] font-semibold m-0 leading-[25.5px]">
                  {layout?.footer?.navigationBar?.leftNavigationBar?.beforeDonateText2}
                </p>
                {layout?.footer?.navigationBar?.leftNavigationBar?.donateButton && (
                  <CMButton
                    buttonType="footerDonateButton"
                    buttonText="DONATE"
                    href="/donate"
                    link={true}
                    className="donate"
                    target={false}
                  ></CMButton>
                )}
              </div>
              <div className="w-[1px] h-[256px] border-0 bg-white max-[1200px]:hidden max-[768px]:hidden"></div>
              <div className="flex w-[338px] h-[260px] justify-center leading-[21.9px] max-[1200px]:inline max-[1200px]:h-full max-[768px]:flex max-[768px]:w-full">
                <div className="max-[1200px]:h-full max-h-full w-full flex flex-wrap flex-col content-between max-[1200px]:justify-unset max-[768px]:justify-start justify-start max-[768px]:content-around">
                  {layout?.footer?.displayMenu &&
                    layout.general?.menu?.map((item: MenuItem, index: number) => (
                      <React.Fragment key={item.name! + index.toString()}>
                        {item.name != 'ABOUT US' && item.name != 'PROFILES' && (
                          <Link
                            className="font-semibold text-base w-fit leading-4 xl:mb-[20px] mb-[13px]"
                            href={item.url!}
                            prefetch={false}
                          >
                            {item.name}
                          </Link>
                        )}
                        {item?.subMenu?.map((link) => (
                          <Link
                            className="font-semibold text-base w-fit leading-4 xl:mb-[20px] mb-[13px]"
                            href={link.url!}
                            key={link.url! + index.toString()}
                            prefetch={false}
                          >
                            {link.name}
                          </Link>
                        ))}
                      </React.Fragment>
                    ))}
                </div>
              </div>
              <div className="flex w-[1px] h-64 border-0 bg-feMy1 max-[1200px]:hidden max-[768px]:hidden"></div>

              <div className="max-[768px]:hidden">
                <NewsletterSignUp
                  {...{
                    newsletterText:
                      layout?.footer?.navigationBar?.rightNavigationBar?.newsletterText,
                  }}
                />
              </div>
            </div>

            <Image
              loading="eager"
              className="max-[1200px]:translate-x-[-51px] max-[1200px]:translate-y-[-42px] max-[768px]:hidden float-right translate-x-[-55px] translate-y-[-47px]"
              alt="bird"
              width={54}
              height={57}
              style={{
                width: '54px',
                height: '57px',
              }}
              src="/images/favicons/bird.svg"
            />
          </div>
        </div>
        <div className="flex justify-center border-t-[1px] border-t-solid leading-[21.9px]">
          <div className="ps-[36px] pe-[45px] flex justify-between w-[1200px] mt-[20px] max-[1200px]:w-[834px] max-[768px]:max-w-full max-[768px]:h-full max-[1200px]:h-[50px] max-[1200px]:mt-0 max-[768px]:p-0 max-[768px]:m-0 max-[768px]:mt-[10px] max-[1200px]:items-center max-[768px]:justify-center">
            <div className="block max-[768px]:text-center max-[768px]:w-[280px] text-sm font-medium leading-[21.9px]">
              Copyright © {new Date().getFullYear()} {CANARY_MISSION.NAME} Inc. All rights reserved.
            </div>

            <div className="max-[768px]:hidden flex justify-between h-[30px] w-auto">
              {layout?.footer?.reportIndicident && (
                <CMButton
                  buttonType="reportIndividualButton"
                  buttonText="REPORT AN INDIVIDUAL"
                  href="/report_an_individual"
                  link={true}
                  className="reportIndividual_footer"
                  target={false}
                >
                  <div className={'mr-1'}>{reportIndividualSvg}</div>
                </CMButton>
              )}
              {layout?.footer?.reportIndicident && (
                <CMButton
                  buttonType="reportIndividualButton"
                  buttonText="REPORT AN EVENT"
                  href="/report_an_event"
                  link={true}
                  className="reportIndividual_footer"
                  target={false}
                >
                  <div className={'mr-1'}>{reportIncidentSvg}</div>
                </CMButton>
              )}
              {layout?.footer?.socialMediaLink &&
                layout.general?.socialMediaLinks?.map((item: SocialLinkItem) => (
                  <SocialMediaLink
                    socialLink={{ link: item.link, platform: item.platform, id: item.id }}
                    width={16}
                    height={16}
                    key={item.link}
                    className={'h-4 w-4'}
                  />
                ))}
            </div>
          </div>
        </div>
      </footer>
    </>
  )
}
export default Footer